import { PortalAnalyticsInlineDialog } from '@atlassian/help-center-common-util/analytics/screens-without-browsermetrics';
import type { RecaptchaFormErrorProps } from './recaptcha-form-error';
import RecaptchaFormErrorAnaltyicsFree from './recaptcha-form-error';

export const RecaptchaFormError = PortalAnalyticsInlineDialog<RecaptchaFormErrorProps>(
	'RecaptchaError',
)(RecaptchaFormErrorAnaltyicsFree);
